import React, { Component, Fragment } from 'react'
import FICRestV2 from 'FICRestV2'
import { Chat, ElementNotFound, HelpHeaderDetailed, MainContainer, PrivacyMessage, Separator } from './customComponents'
import HtmlToReact, { Parser as HtmlToReactParser } from 'html-to-react'
import styled, { css } from 'styled-components'
import FICColors from 'FICColors'
import BreadCrumbs from './BreadCrumbs'
import { SubArticle } from './SubArticle.js'
import ContentLoader from 'react-content-loader'
import { FALIcon } from 'FAIcon'
import { Link } from 'react-scroll'
import FICTextButton from 'FICTextButton'
import FICInputText from 'FICInputText'
import FICActionButton from 'FICActionButton'
import FICTooltip from 'FICTooltip'
import { debounce } from 'lodash'

const sidebarOffsetTop = !localStorage.getItem('helpFacebookBannerIsVisible') ? 50 : 40
const helpHeaderHeight = !localStorage.getItem('helpFacebookBannerIsVisible') ? 130 : 90
const maxBottomOffset = 500
const breadCrumbsHeight = 64

export default class Article extends Component {
  constructor (props) {
    super(props)
    this.state = this.initialState
    this.sections = {}
  }

  get initialState () {
    return {
      article: false,
      relatedArticles: [],
      chat: [],
      tree: false,
      feedbackText: '',
      fixedSideBar: false,
      fixedSideBarMaxBottom: false,
      currentSection: 0,
      parentsArticle: this.props.parentsArticle || [],
      elementNotFound: false,
      viewportWidth: 0
    }
  }

  componentDidMount () {
    this.updateViewporWidth()
    this.loadData()
    this.parent = ReactDOM.findDOMNode(this)
    this.parent.addEventListener('scroll', this.listenScrollEvent)
    window.addEventListener('resize', debounce(this.updateViewporWidth, 100))
    if (this.props.isExternal) {
      const mainContainer = this.parent.parentNode.parentNode.parentNode
      mainContainer.scrollTop = 0
    }
  }

  componentDidUpdate (prevProp) {
    if (this.props.searchKey !== prevProp.searchKey) {
      this.sections = {}
      this.loadData(this.props.searchKey)

      const node = ReactDOM.findDOMNode(this)
      const mainContainer = node.parentNode.parentNode.parentNode
      mainContainer.scrollTop = 0
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', debounce(this.updateViewporWidth, 100))
  }

  updateViewporWidth = () => {
    this.setState({ viewportWidth: window.innerWidth })
  }

  listenScrollEvent = e => {
    if (this.state.viewportWidth <= 768) {
      if (this.state.fixedSideBar) {
        this.setState({ fixedSideBar: false })
      }
      return
    }

    if (_.size(this.sections) === 0) {
      return
    }

    if (this.container) {
      const containerNode = ReactDOM.findDOMNode(this.container)

      if (containerNode) {
        const offset = containerNode.offsetTop + breadCrumbsHeight + this.helpHeaderDetailed.offsetHeight - (this.props.isExternal ? helpHeaderHeight : sidebarOffsetTop)
        const offsetBottom = this.articleContainer.getBoundingClientRect().bottom

        if (this.parent.scrollTop > offset && !this.state.fixedSideBar) {
          this.setState({ fixedSideBar: true })
        } else if (this.parent.scrollTop < offset && this.state.fixedSideBar) {
          this.setState({ fixedSideBar: false })
        }
        if (offsetBottom <= maxBottomOffset && !this.state.fixedSideBarMaxBottom) {
          this.setState({ fixedSideBarMaxBottom: true })
        } else if (offsetBottom > maxBottomOffset && this.state.fixedSideBarMaxBottom) {
          this.setState({ fixedSideBarMaxBottom: false })
        }
      }
    }

    let current = 0
    _.forEach(this.sections, (section, sectionNumber) => {
      if (section.node && section.node.offsetTop !== undefined) {
        section.top = section.node.offsetTop
      }

      if (section.top < (this.parent.scrollTop + 200)) {
        current = sectionNumber
      }
    })

    if (current !== this.state.currentSection) {
      this.setState({ currentSection: current })
    }
  }

  loadData = (searchKey) => {
    if (searchKey === undefined) {
      searchKey = this.props.searchKey
    }
    FICRestV2.get({
      request: 'help/article/' + searchKey,
      queryData: { realm: this.props.realm, is_dev: window.location.host.includes('-dev') ? 1 : 0 },
      onSuccess: (response) => {
        this.setState({
          article: response.data,
          relatedArticles: response.related_articles,
          tree: response.tree,
          chat: response.chat,
          sidebar: response.sidebar
        })
      },
      onError: () => {
        this.setState({ ...this.initialState, elementNotFound: true })
      }
    })
  }

  getBreadCrumbs = () => {
    let breadCrumbPaths = []
    let c = 3
    while (c >= 1) {
      if (this.state.tree && this.state.tree[ 'section' + c + '_permalink' ]) {
        const permalink = this.state.tree[ 'section' + c + '_permalink' ]
        breadCrumbPaths.push({ text: this.state.tree[ 'section' + c + '_title' ], onClick: () => this.props.changeView(permalink, 'sezione') })
      }
      c--
    }

    return breadCrumbPaths
  }

  handleChange = (key, comment) => {
    this.setState({ feedbackComment: comment, counter: comment.length })
  }

  saveFeedback = (feedback) => {
    FICRestV2.post({
      request: 'help/feedback',
      postData: {
        data: {
          article_id: this.state.article.id,
          feedback: feedback || this.state.feedback,
          feedback_comment: this.state.feedbackComment,
          feedback_id: this.state.feedbackId
        }
      },
      onSuccess: (response) => {
        this.setState({
          feedback: feedback || this.state.feedback,
          feedbackId: response.data.id,
          feedbackCompleted: response.data.commented
        })
      },
      onError: () => {
        // Do not show alert
        this.setState({
          feedback: 'yes'
        })
      }
    })
  }

  renderSideBar = () => {
    return (
      <SideBar
        fixedSideBar={this.state.fixedSideBar}
        fixedSideBarMaxBottom={this.state.fixedSideBarMaxBottom}
        isExternal={this.props.isExternal}
      >
        <h2>In questa guida</h2>
        {this.state.sidebar.map((link, idx) => {
          return (
            <SectionLink
              key={idx}
              to={link.id}
              smooth
              offset={-100}
              containerId={'articleContainer'}
              className={parseInt(this.state.currentSection) === idx ? 'active' : undefined}
              isActive={this.state.currentSection > idx ? true : undefined}
            >{link.title}</SectionLink>
          )
        }
        )}
      </SideBar>)
  }

  renderFeedback = () => {
    return (
      <Feedback valid={this.state.feedbackComment}>
        <h3>L'articolo è stato utile?</h3>
        <div className='buttons'>
          {this.state.feedback === undefined
            ? <Fragment>
              <FICTextButton onClick={() => this.saveFeedback('yes')} iconLeft={[ 'fal', 'thumbs-up' ]} text='Si, Grazie!' className='yes' />
              <FICTextButton onClick={() => this.saveFeedback('no')} iconLeft={[ 'fal', 'thumbs-down' ]} text='Non è servito' className='no' />
            </Fragment>
            : this.state.feedback === 'yes' || this.state.feedbackCompleted
              ? <p>Grazie per aver lasciato il tuo feedback!</p>
              : <p>Ci dispiace di non esserti stati di aiuto.<br />Se vuoi puoi lasciare un commento per dirci come migliorare.</p>

          }
        </div>
        {this.state.feedback === 'no' && !this.state.feedbackCompleted &&
        <div className='comment'>
          <FICInputText type='multiline' name='feedbackComment' maxLength={600} onChange={this.handleChange} value={this.state.feedbackComment} />
          <div>
            <Counter>{this.state.counter ? this.state.counter : '0'}/600</Counter>
            <FICTextButton text='Invia feedback' onClick={this.state.feedbackComment ? this.saveFeedback : null} />
          </div>
        </div>
        }
      </Feedback>
    )
  }

  renderRelatedArticles = () => {
    return (
      <RelatedArticles>
        <h3>Articoli correlati</h3>
        <ul>
          {this.state.relatedArticles.map((article, idx) => {
            return (
              <li key={idx} onClick={() => this.props.changeView(article.permalink, 'articolo')}>
                <span>{article.title}</span>
              </li>
            )
          })
          }
        </ul>
      </RelatedArticles>
    )
  }

  print = () => {
    let mywindow = window.open('', 'PRINT', 'height=800,width=1200')

    mywindow.document.write('<html><head><title>' + this.state.article.title + '</title>')
    mywindow.document.write('<link href=\'https://fonts.googleapis.com/css?family=Open+Sans:300italic,400italic,600italic,700italic,800italic,400,300,600,700,800\' rel=\'stylesheet\' type=\'text/css\' />')
    mywindow.document.write('<link rel="stylesheet" type="text/css" href="/assets/libs/font-awesome-4.7.0/css/font-awesome.min.css?" media="print, screen" />')
    mywindow.document.write('<link rel="stylesheet" href="https://pro.fontawesome.com/releases/v5.11.2/css/all.css" integrity="sha384-zrnmn8R8KkWl12rAZFt4yKjxplaDaT7/EUkKm7AovijfrQItFWR7O/JJn4DAa/gx" crossorigin="anonymous">')
    mywindow.document.write('<link rel="stylesheet" type="text/css" href="/css/help-print-article.css?r=4" media="print, screen" />')
    mywindow.document.write('</head><body >')
    mywindow.document.write('<h1>' + this.state.article.title + '</h1>')
    mywindow.document.write(document.getElementById('printSection-' + this.props.searchKey).innerHTML)
    mywindow.document.write('</body></html>')

    mywindow.document.close() // necessary for IE >= 10
    mywindow.focus() // necessary for IE >= 10

    setTimeout(
      () => {
        mywindow.print()
        mywindow.close()
      }, 500)

    return true
  }

  renderActions = () => {
    return (
      <Actions>
        {this.state.viewportWidth > 768 &&
        <FICTooltip placement='top' text='Stampa' delayShow={200}>
          <FALIcon name='print' onClick={this.print} />
        </FICTooltip>
        }
        {!this.props.subArticle && !this.props.isExternal &&
        <FICTooltip placement='top' text='Apri in nuova scheda' delayShow={200}>
          <FICActionButton icon={[ 'fal', 'external-link' ]} href={'/help/articolo/' + this.state.article.permalink} target='_blank' />
        </FICTooltip>
        }
      </Actions>
    )
  }

  render () {
    const props = this.props
    const state = this.state
    const htmlToReactParser = new HtmlToReactParser()
    const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React)
    const processingInstructions = [
      {
        shouldProcessNode: (node) => {
          return node.name === 'reactelement'
        },
        processNode: (node, children) => {
          if (node.attribs.type === 'article') {
            return <SubArticle
              key={node.attribs.key}
              text={node.attribs.title}
              permalink={node.attribs.permalink}
              className='subArticle'
              realm={this.props.realm}
              changeView={props.changeView}
              parentsArticle={this.state.parentsArticle}
              isInternal={this.props.isInternal}
            />
          } else {
            return <CustomBlock
              key={node.attribs.key}
              type={node.attribs.type}
              text={node.attribs.text}
              color={node.attribs.color ? node.attribs.color : undefined}
              id={node.attribs.type === 'section' ? node.attribs.id : undefined}
              className='customBlock'
              ref={block => {
                if (block && node.attribs.type === 'section') {
                  const sectionNode = ReactDOM.findDOMNode(block)
                  this.sections[ parseInt(node.attribs.section_number) ] = { node: sectionNode, top: null }
                }
              }}
            />
          }
        }
      },
      {
        // Anything else
        shouldProcessNode: function (node) {
          return true
        },
        processNode: processNodeDefinitions.processDefaultNode
      }
    ]

    return (
      <MainContainer
        className={props.className}
        id='articleContainer'
        isExternal={props.isExternal}
        ref={node => this.container = node}
      >
        {!props.subArticle &&
        <Fragment>
          <HelpHeaderDetailed
            closeIcon={!this.props.embedded}
            onClickClose={props.onClickClose}
            onClick={() => props.changeView(state.article.parent_section, 'sezione')}
            title={state.article.title}
            isExternal={props.isExternal}
            realm={this.props.realm}
            ref={headerRef => this.helpHeaderDetailed = headerRef}
            embedded={this.props.embedded}
          />
          <BreadCrumbs
            onSelect={props.changeView}
            paths={this.getBreadCrumbs()}
            className='breadCrumbs'
            realm={this.props.realm}
            embedded={this.props.embedded}
          />
        </Fragment>
        }
        {!state.article
          ? this.state.elementNotFound
            ? <ElementNotFound type='article' onClick={this.props.changeView} />
            : <ArticleLoading className='articleContainer' />
          : <ArticleContainer
            className={`articleContainer ${this.props.embedded ? 'embeddedArticle' : ''}`}
            subArticle={props.subArticle}
            ref={ref => this.articleContainer = ref}
          >
            {!props.subArticle && state.sidebar && this.renderSideBar()}
            <ArticleContent fixedSideBar={state.fixedSideBar} embedded={this.props.embedded}>
              {this.renderActions()}
              <div id={'printSection-' + this.props.searchKey}>
                {htmlToReactParser.parseWithInstructions(state.article.content, () => {
                  return true
                }, processingInstructions)}
              </div>
              {!props.subArticle && !state.article.feedback && this.renderFeedback()}
              {(state.relatedArticles.length > 0 && !props.subArticle) && this.renderRelatedArticles()}
            </ArticleContent>
          </ArticleContainer>
        }
        {(state.chat.open && reactGlobalParams.chat.help_visible && !props.subArticle) && !this.state.elementNotFound &&
        <Fragment>
          <Separator />
          <Chat warning={state.chat.warning} type='article' id={state.article.id} />
          <PrivacyMessage isFic={this.props.realm === 'fic'} />
        </Fragment>
        }
      </MainContainer>
    )
  }
}

const ArticleContainer = styled.div`
  margin: ${props => props.subArticle ? undefined : '40px auto'};
  width: 100%;
  max-width: 968px;
  text-align: center;
  @media (max-width: 425px) {
    margin-top: 0;
    table{
      table-layout: fixed;
      ul{
        margin: 0 15px 15px 0;
        list-style-position: inside;
        overflow: scroll;
        li{
          text-align: left!important;
          margin-bottom: 10px;  
        }
      }
    }
  }
`

const LinkPoint = styled.span`
  height: 8px;
  width: 8px;
  background-color: #0294D3;
  display: block;
  border-radius: 100%;
  position: absolute;
  top:10px;
  transition: height 100ms ease-out;
`

const SectionLinkImpl = ({ className, isActive, ...props }) => <div className={className}>
  <LinkPoint className='point' />
  <Link {...props} />
</div>
const SectionLink = styled(SectionLinkImpl)`
  font-size: 16px;
  line-height: 24px;
  display: block;
  cursor: pointer;
  position: relative;
  &:not(:last-child){
    a{padding-bottom: 16px}
  }
  &.active{
    a{
      color: #0294D3;
      font-weight: bold;
    }
  }
  a{
    display: inline-block;
    color: #333;
    margin-left: 20px;
    vert-align: top;
    position: relative;
    max-width: 244px;
    &:hover{text-decoration: none}
  }
  ${props => props.isActive && css`
    .point{
      height: 115%;
      border-radius: 4px;
    }
  `}
`

const SideBarImpl = ({ className, ...props }) => <div className={className}>
  {props.children}
</div>
const SideBar = styled(SideBarImpl)`
  width: 296px;
  border-radius: 4px;
  background-color: #F2F4F8;
  padding: 16px;
  box-sizing: border-box;
  vertical-align: top;
  margin-right: 24px;
  display: inline-block;
  text-align: left;
  transition:visibility 0.1s linear,opacity 0.1s linear;
  visibility: visible;
  opacity: 1;
  @media (max-width: 425px) {
    width: 100%;
    margin-right: 0;
    margin-bottom: 24px;
  }
  ${props => props.fixedSideBar && css`
    position: absolute;
    top:${sidebarOffsetTop + (props.isExternal ? helpHeaderHeight : 0)}px;
  `}
  ${props => props.fixedSideBarMaxBottom && css`
    opacity: 0;
    visibility: hidden;
  `}
  h2{
    color: #333333;
    font-size: 20px;
    font-weight: bold;
    line-height: 40px;
  }
`

const ArticleContent = styled.div`
  display: inline-block;  
  max-width: ${props => props.embedded ? '448px' : '616px'};
  padding-left: 16px;
  padding-right: 16px;
  color: ${FICColors.textDefault};
  font-size: 16px;
  line-height: 24px;
  vertical-align: top;
  text-align: left;
  ${props => props.fixedSideBar && css`
    margin-left: 320px;
  `}
  li{line-height: 24px;}
  p{margin: 0 0 10px;}
  img{
    border: 1px solid rgba(51,51,51,0.24);
    padding:10px;
    box-sizing: border-box;
    height:auto!important;
    border-radius: 4px;
  }
  h2,h3{line-height: 40px}
  h3{margin-bottom: 16px}
`

const RelatedArticlesImpl = ({ className, ...props }) => <div className={className}>{props.children}</div>
const RelatedArticles = styled(RelatedArticlesImpl)`
  border-top:1px solid rgba(51,51,51,0.08);
  padding-top: 24px;
  margin-top: 24px;
  h3{
    line-height: 40px;
    margin-bottom: 16px;
    font-size: 18px;
  }
  ul{
    padding: 0;
    -webkit-column-count: 2; /* Chrome, Safari, Opera */
    -moz-column-count: 2; /* Firefox */
    column-count: 2;
    -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
    -moz-column-gap: 40px; /* Firefox */
    column-gap: 40px;
    margin-left: 10px;
    li{
      color: ${FICColors.textDefault};
      margin-bottom: 20px;
      margin-left:10px;
      font-size: 16px;
      width: 100%;
      -webkit-column-break-inside: avoid;
      page-break-inside: avoid;
      break-inside: avoid;
      span{
        cursor: pointer;
        color: ${FICColors.defaultBlue};
        &:hover{
          text-decoration: underline;
          &::before {text-decoration: none;}
        }
      }
    }
  }
`

const ArticleLoadingSvg = ({ className, ...props }) => <div className={className + ' articleLoading'}>
  <ContentLoader
    height={160}
    width={300}
    speed={2}
    primaryColor='#f3f3f3'
    secondaryColor='#ecebeb'
    className={props.className}
  >
    <rect x='5' y='2' rx='3' ry='3' width='70' height='10' />
    <rect x='85' y='2' rx='3' ry='3' width='100' height='10' />
    <rect x='195' y='2' rx='3' ry='3' width='10' height='10' />
    <rect x='20' y='22' rx='3' ry='3' width='130' height='10' />
    <rect x='160' y='22' rx='3' ry='3' width='130' height='10' />
    <rect x='20' y='42' rx='3' ry='3' width='90' height='10' />
    <rect x='120' y='42' rx='3' ry='3' width='60' height='10' />
    <rect x='190' y='42' rx='3' ry='3' width='60' height='10' />
    <rect x='5' y='102' rx='3' ry='3' width='30' height='10' />
    <rect x='19' y='81' rx='3' ry='3' width='90' height='10' />
    <rect x='119' y='81' rx='3' ry='3' width='60' height='10' />
    <rect x='189' y='81' rx='3' ry='3' width='60' height='10' />
    <rect x='20' y='62' rx='3' ry='3' width='130' height='10' />
    <rect x='173' y='60' rx='3' ry='3' width='130' height='10' />
  </ContentLoader>
</div>
const ArticleLoading = styled(ArticleLoadingSvg)`
  height:160px;  
  width: 100%;
  margin: 0 auto;
  max-width: 940px;
  svg{width: 300px}
  ${props => !props.isExternal && css`
    margin: 15px auto;
  `}
`

function customBlockIcon (type) {
  let icon
  switch (type) {
    case 'hint':
      icon = 'magic'
      break
    case 'note':
      icon = 'pencil'
      break
    case 'warning':
      icon = 'exclamation-triangle'
      break
  }
  if (icon !== '') {
    return <FALIcon name={icon} />
  }
}

class CustomBlockImpl extends Component {
  render () {
    const { className, ...props } = this.props
    const htmlToReactParser = new HtmlToReactParser()

    return (
      <div className={className + ' ' + props.type} id={props.id ? props.id : undefined}>
        {customBlockIcon(props.type)}
        <div className='text'>{htmlToReactParser.parse(props.text)}</div>
      </div>
    )
  }
}

const CustomBlock = styled(CustomBlockImpl)`
  padding: 12px;
  border: 1px solid rgba(51,51,51,0.24);
  border-radius: 4px;
  margin: 24px auto;
  .fa, .faicon{
    padding-right: 12px;
    font-size: 23px;
    display: table-cell;
    vertical-align: middle;
  }
  &.hint{
    border-color: #0078CD;
    background-color: rgba(0,120,205,0.08);
    .fa, .faicon{color:#0078CD}
  }
  &.note{
    border-color: #23C499;
    background-color: rgba(35,196,153,0.08);
    .fa, .faicon{color:#23C499}
  }
  &.warning{
    border-color: #FFBE2D;
    background-color: rgba(255,190,45,0.08);
    .fa, .faicon{color:#FFBE2D}
  }
  .text{
    display: table-cell;
    vertical-align: top;
    width: calc(100% - 35px);
  }
  &.section{
    border-radius: 0;
    border: none;
    border-bottom: 1px solid rgba(51,51,51,0.24);
    font-size: 22px;
    font-weight: bold;
    line-height: 30px;
    padding: 24px 0 5px 0;
    margin-top: 0!important;
    box-shadow: none;
    &:first-child{padding-top: 0;}
    &:not(:first-child){margin-top: 32px}
    .fa, .faicon{display: none}
  }
`

const Feedback = styled.div`
  padding: 24px 0 0;
  border-top: 1px solid rgba(51,51,51,0.08);
  h3{
    font-size: 18px;
    font-weight: bold;
    line-height: 32px;
    text-align: center;
    margin: 0;
    color: ${FICColors.textDefault};
  }
  .buttons{
    text-align: center;
    margin: 24px auto;
    .fic-text-button {
      height: 40px!important;
      max-height: unset!important;
      padding-top: 10px!important;
      box-sizing: border-box;
      border: 2px solid #0294D3;
      font-size: 16px;
      text-transform: unset;
      font-weight: normal;
      width: 160px;
      @media all and (-ms-high-contrast: none) {
        & { padding:5px 14px 14px!important; }  
     }
      &.yes{
        background-color: ${FICColors.white};
        color:#0294D3;
        margin-right: 12px;
        @media (max-width: 425px) {
          width: 152px;
          margin-right: 16px;
        }
        @media (max-width: 350px) {
          margin-right: 0;
          margin-bottom: 16px;
        }
        &:hover{
          background-color: #0294D3;
          color: ${FICColors.white};
          .fa, .faicon{color: ${FICColors.white};}
        }
      }
      &.no{
        background-color: #0294D3;
        border-color: #0294D3;
        margin-left: 12px;
        @media (max-width: 425px) {
          width: 152px;
          margin-left: 0;
        }
        &:hover{
          background-color: ${FICColors.white};
          color:#0294D3;
        }
      }
    }
  }
  .comment{
    padding-bottom: 38px;
    .fic-input-text-input{
      width: 100%;
      height: 140px!important;
      margin-bottom: 16px;   
      box-sizing: border-box; 
    }
    .fic-text-button{
      height: 40px!important;
      max-height: unset!important;
      padding-top: 10px!important;
      box-sizing: border-box;
      font-weight: normal;
      font-size: 16px;
      text-transform: unset;     
      border: 2px solid #F2F4F8;
      background-color: #F2F4F8;
      color: rgba(51,51,51,0.16);
      cursor: auto;
      float: right;
      ${props => props.valid && css`
        background-color: #0294D3;
        color: ${FICColors.white};
        border: 2px solid #0294D3;
        cursor: pointer;
        &:hover{
          background-color: ${FICColors.white};
          color:#0294D3;
        }
      `} 
    }
  }
`

const Counter = styled.div`
  color: rgba(51,51,51,0.72);
  font-size: 12px;
  line-height: 16px;
  float: left;
`

const Actions = styled.div`
  text-align: right;
  margin-bottom: 10px;
  a{
    margin-left: 10px;
    position: relative;
    top:-5px;
  }
  a, a:hover, a:focus {
    text-decoration: none;
  }
  .faicon{
    display: inline-block;
    color:#555!important;
    font-size:22px;
    cursor: pointer;
    &:hover{color:${FICColors.defaultBlue}!important;}
  }
`



// WEBPACK FOOTER //
// ./src/help/common/Article.js